var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinEq14(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 68,
    viewBox: "0 0 54 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_895_5855)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_895_5855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 67.5C17.9419 59.7919 11.1789 52.6369 6.70645 46.0263C2.23403 39.4156 0 33.3015 0 27.675C0 19.2353 2.71306 12.5158 8.14355 7.50774C13.5697 2.50403 19.8581 0 27 0C34.1419 0 40.4303 2.50403 45.8565 7.50774C51.2826 12.5158 54 19.2353 54 27.675C54 33.3015 51.766 39.4156 47.2935 46.0263C42.8211 52.6369 36.0581 59.7919 27 67.5V67.5Z",
    fill: "#2E197E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 27.675C0.5 19.353 3.16975 12.7748 8.4825 7.87531L8.48252 7.8753C13.8197 2.95359 19.9883 0.5 27 0.5C34.0117 0.5 40.1802 2.95355 45.5173 7.87517C50.826 12.7748 53.5 19.3532 53.5 27.675C53.5 33.1679 51.3183 39.185 46.8794 45.7461C42.4947 52.2272 35.8757 59.2569 27 66.8429C18.1243 59.2569 11.5053 52.2272 7.12058 45.7461C2.68166 39.185 0.5 33.1679 0.5 27.675Z",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 48.87C39.3742 48.87 49.4055 38.8387 49.4055 26.4644C49.4055 14.0901 39.3742 4.05872 26.9999 4.05872C14.6256 4.05872 4.59424 14.0901 4.59424 26.4644C4.59424 38.8387 14.6256 48.87 26.9999 48.87Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.075 27.95C23.075 25.22 24.0175 22.9125 25.9025 21.0275C27.7875 19.1425 30.095 18.2 32.825 18.2V20.15C30.6367 20.15 28.7896 20.9029 27.2837 22.4087C25.7779 23.9146 25.025 25.7617 25.025 27.95H23.075ZM26.975 27.95C26.975 26.325 27.5437 24.9437 28.6812 23.8062C29.8187 22.6687 31.2 22.1 32.825 22.1V24.05C31.7417 24.05 30.8208 24.4292 30.0625 25.1875C29.3042 25.9458 28.925 26.8667 28.925 27.95H26.975ZM16.575 17.875C15.9033 17.875 15.3292 17.6367 14.8525 17.16C14.3758 16.6833 14.1375 16.1092 14.1375 15.4375C14.1375 14.7658 14.3758 14.1917 14.8525 13.715C15.3292 13.2383 15.9033 13 16.575 13C17.2467 13 17.8208 13.2383 18.2975 13.715C18.7742 14.1917 19.0125 14.7658 19.0125 15.4375C19.0125 16.1092 18.7742 16.6833 18.2975 17.16C17.8208 17.6367 17.2467 17.875 16.575 17.875ZM13 24.2125V21.2875C13 20.8325 13.1625 20.4479 13.4875 20.1337C13.8125 19.8196 14.1917 19.6625 14.625 19.6625H18.525C19.565 19.6625 20.4533 19.3592 21.19 18.7525C21.9267 18.1458 22.4033 17.3658 22.62 16.4125H24.6025C24.4292 17.5825 23.9363 18.6117 23.1238 19.5C22.3113 20.3883 21.32 21.0167 20.15 21.385V24.2125H13ZM35.425 32.6625C34.7533 32.6625 34.1792 32.4242 33.7025 31.9475C33.2258 31.4708 32.9875 30.8967 32.9875 30.225C32.9875 29.5533 33.2258 28.9792 33.7025 28.5025C34.1792 28.0258 34.7533 27.7875 35.425 27.7875C36.0967 27.7875 36.6708 28.0258 37.1475 28.5025C37.6242 28.9792 37.8625 29.5533 37.8625 30.225C37.8625 30.8967 37.6242 31.4708 37.1475 31.9475C36.6708 32.4242 36.0967 32.6625 35.425 32.6625ZM31.85 39V36.1725C30.68 35.8042 29.6887 35.1758 28.8762 34.2875C28.0637 33.3992 27.5708 32.37 27.3975 31.2H29.38C29.5967 32.1533 30.0733 32.9333 30.81 33.54C31.5467 34.1467 32.435 34.45 33.475 34.45H37.375C37.83 34.45 38.2146 34.6071 38.5288 34.9212C38.8429 35.2354 39 35.62 39 36.075V39H31.85Z",
    fill: "#516274"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_895_5855",
    x: -4,
    y: 0,
    width: 62,
    height: 75.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_895_5855"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_895_5855",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_895_5855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 67.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinEq14);
export default __webpack_public_path__ + "static/media/pin-eq-14.133eb810307e6bcd9d61fe9aac270424.svg";
export { ForwardRef as ReactComponent };